import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { isProgramHasOneTimePayment } from '../../../selectors/payment/oneTimePayment';
import { isUserJoinedAlreadyWithoutSuspended } from '../../../contexts/User/helpers/userTypeHandlers';
import { isPrivateChallenge } from '../../../selectors/isPrivateChallenge';
import { getParticipantState } from '../../../selectors/participant/getState';
import { State as ParticipantState } from '@wix/ambassador-challenges-v1-participant/types';

export function needToRedirectBackToVisitorPage({
  initialProps,
  flowAPI,
}: {
  initialProps: any;
  flowAPI: ControllerFlowAPI;
}) {
  if (!flowAPI.environment.isViewer) {
    return false;
  }

  const participant = initialProps?.participant;
  const challenge = initialProps?.challengeData?.challenge;

  return (
    !isProgramHasOneTimePayment(challenge) ||
    isUserJoinedAlreadyWithoutSuspended(getParticipantState(participant)) ||
    (isPrivateChallenge(challenge) &&
      getParticipantState(participant) === ParticipantState.JOIN_REQUESTED)
  );
}
